import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_DATE_FORMAT } from 'src/app/core/ccomx-date-formats';
import { markControlsAsTouched } from 'src/app/shared/functions/mark-controls-as-touched';
import { UseMedicineStockForm } from '../../forms/use-medicine-stock.form';
import { IMedicineStockBatch } from '../../models/medicine.model';
import { IUseMedicineRequest } from '../../models/use-medicine.model';

const STOCK_QUANTITY_DECIMAL_PLACES = 2;

export interface UseMedicineStockModalData {
  id: string;
  stockBatches: IMedicineStockBatch[];
}

@Component({
  selector: 'app-use-medicine-stock-modal',
  templateUrl: './use-medicine-stock-modal.component.html',
  styleUrls: ['./use-medicine-stock-modal.component.scss'],
  standalone: false,
})
export class UseMedicineStockModalComponent {
  form = new UseMedicineStockForm(this.data.stockBatches);

  constructor(
    public dialogRef: MatDialogRef<UseMedicineStockModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UseMedicineStockModalData,
    private translate: TranslateService,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  get totalAmount(): number {
    const total = this.form.batches.controls.reduce(
      (sum, batch) => sum + Number(batch.controls.amount.value || 0),
      0
    );
    return Number(total.toFixed(STOCK_QUANTITY_DECIMAL_PLACES));
  }

  getBatchAmountAriaLabel(index: number): string {
    const expiry = this.data.stockBatches[index]?.expires
      ? formatDate(this.data.stockBatches[index].expires, DEFAULT_DATE_FORMAT, this.locale)
      : this.translate.instant('noExpiry');

    return `${this.translate.instant('amount')} — ${expiry}`;
  }

  save(): void {
    markControlsAsTouched(this.form);
    if (!this.form.valid) {
      return;
    }

    const result: IUseMedicineRequest = {
      id: this.data.id,
      amount: this.totalAmount,
      reason: this.form.reason.value,
      adjustmentAttachments: [],
      batches: this.form.batches.getRawValue().filter((batch) => batch.amount > 0),
    };
    this.dialogRef.close(result);
  }
}
